import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../api/client';

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(null);
  const [pages, setPages] = useState([]);
  const [categories, setCategories] = useState([]);

  const refresh = async () => {
    try {
      const [s, p, c] = await Promise.all([
        api.getSite(),
        api.listPages({ published: true }),
        api.listCategories({ published: true }),
      ]);
      setSite(s);
      setPages(p);
      setCategories(c);
    } catch (e) { console.error('SiteContext refresh failed:', e); }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <SiteContext.Provider value={{ site, pages, categories, refresh }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext) || { site: null, pages: [], categories: [], refresh: () => {} };
